import SortFilter from '@com/shared/ocs/filter/sortFilter';

const FILTER_OPTIONS = [
  { label: 'ارزان‌ترین', value: 'true' },
  { label: 'گرانترین', value: 'false' },
];

const Filter = () => {
  return (
    <div className="flex items-center px-4 py-2">
      <SortFilter
        title="مرتب‌سازی"
        paramKey="SortAscending"
        defaultLabel="مرتب‌سازی"
        options={FILTER_OPTIONS}
        disablePageNumberQuerySet
      />
    </div>
  );
};

export default Filter;
